import React, { Component } from "react";
import "./style.scss";
import FilterSection from "./FilterSection";
import _ from 'lodash'
import Spinner from '~/components/Spinner';
import { getFilteredContent } from '~/redux/video/helpers'

import {
  fetchTags,
  saveFilterItemsToClientStorage,
  getCachedTags
} from "./helpers";

class Filter extends Component {

  constructor(props) {
    super(props);
    this.state = {
      explicit: [],
      loadingFilterItems: false,
      classesData: _.get(this.props.filterState, 'classesData', []),
      classesButtonLabel: _.get(this.props.filterState, 'classesButtonLabel', 'SHOW ALL CLASSES'),
      filterTags: {},
      concepts: this.props.selectedCategory,
      chosenTags: _.get(this.props.filterState, 'chosenTags', {})
    };
  }

  componentDidMount() {
    const cachedTags = getCachedTags();
    if (cachedTags) {
      return this.setState({
        filterTags: cachedTags.filterTags, 
        loadingFilterItems: false
      }, () => Object.keys(this.state.chosenTags) == 0 ? this.setChosenTags() : null);
    } else {
      this.setState({
        loadingFilterItems: true
      })
      fetchTags().then(tags => {
        let allFilterTags = _.groupBy(tags, 'tagType');
        let filterTags = {};
        if(allFilterTags['language'].length > 0) {
          filterTags = _.omit(allFilterTags, ['language']);
          filterTags['explicit'] = [{'title':'Filter Out'}]
        } else {
          filterTags = allFilterTags;
        }
        this.setState({
          filterTags
        }, () => {
          saveFilterItemsToClientStorage(filterTags);
          // maintain new state of chosenTags only if there is no previous filter state
          if(Object.keys(this.state.chosenTags).length === 0){
            this.setChosenTags();
          }
          this.setState({
            loadingFilterItems: false
          })
        });
      });
    }
  }

  setChosenTags = () => {
    let chosenTags = _.merge({}, this.state.filterTags);
    Object.keys(chosenTags).map((key) => { chosenTags[key].length = 0;});
    this.setState({
      chosenTags : chosenTags
    });
  }

  setClassesButtonLabel = (state, length) => {
    let tags = Object.keys(this.state.chosenTags).filter((key) => {
      return this.state.chosenTags[key].length > 0
    })
      if(_.isEmpty(tags) && length > 0) {
          this.setState({
              classesButtonLabel: 'SHOW ALL CLASSES'
          })
      } else {
          if(length == 0) {
              this.setState({
                  classesButtonLabel: `No results matching your selections`
              })
          } else {
              this.setState({
                  classesButtonLabel: `SHOW ${length} CLASSES`
              })
          }
      }
  }
  toggleMaker = a => (itemToToggle, labelName) => {
    let chosenTags = this.state.chosenTags;

    if(chosenTags[labelName].includes(itemToToggle)) {
      var index = chosenTags[labelName].indexOf(itemToToggle);
      if (index !== -1) {
        chosenTags[labelName].splice(index, 1);
      }
    } else {
      chosenTags[labelName].push(itemToToggle);
    }
    this.setState({
      ...chosenTags,
      loadingClassesCount: true
    })
    getFilteredContent('vodOnly',this.state.chosenTags, this.state.concepts, 0, true)
    .then((data) => {
      this.setState({
          classesData: data,
          loadingClassesCount: false
      })
      this.setClassesButtonLabel(this.state, data.total);
    })
  };
  clearAll = () => {
    this.setChosenTags();
    this.setState({
      classesButtonLabel: 'SHOW ALL CLASSES'
    })
  }
  renderFilters = () => {
      const toggleItemSelection = this.toggleMaker(),
      filterTags = this.state.filterTags,
      chosenFilterTags = this.state.chosenTags;
    return <FilterSection {...{toggleItemSelection, filterTags, chosenFilterTags}} />
  };
  handleSearch = () => {
      if(this.state.classesButtonLabel == 'SHOW ALL CLASSES') {
        getFilteredContent('vodOnly',this.state.chosenTags, this.state.concepts, 0, true)
          .then((data) => {
            console.log(data);
            this.setState({
                classesData: data
            },() => {
                this.props.handleSearch(this.state.classesData)
                this.props.getPrevFilterState(this.state)
            })
        })
    } else {
        this.props.handleSearch(this.state.classesData)
        this.props.getPrevFilterState(this.state)
    }
  }
  render() {
    const { isOpen } = this.props;
    return (
      <div className={`search-slidein ${isOpen ? "" : "is-closed"} filter-overlay`}>
        <div className="dispFlex">
            <button
              className="search-slidein-close"
              onClick={this.clearAll}>
              Clear All
            </button>
            <div className="search-heading"> FILTER </div>
            <button
              className="search-slidein-close"
              style={{textAlign: 'right'}}
              onClick={this.props.toggleMenu}>
              <i className="ion-close"></i>
            </button>
        </div>
        <div className="filter-tags-wrapper">
          {this.renderFilters()}
          {this.state.loadingFilterItems && <Spinner/>}
        </div>
       
        <div className="slide-button-container">
            <button className="search-slidein-button" onClick={this.handleSearch}>
              {this.state.classesButtonLabel}
              {this.state.loadingClassesCount && <Spinner/>}
            </button>
        </div>
      </div>
    );
  }
}

export default Filter;
